import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import VenueCard from "@/components/VenueCard";
import { Button } from "@/components/ui/button";
import { Heart } from "lucide-react";

export default function SavedPlaces() {
  const [venues, setVenues] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/saves").then(r => setVenues(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-lg bg-red-500 text-white flex items-center justify-center"><Heart className="w-6 h-6"/></div>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-gray-900">Saved places</h1>
      </div>
      <p className="mt-3 text-gray-700 max-w-2xl">Your bookmarked accessible places. Tap the heart on any venue card to save it.</p>

      {loading ? (
        <div className="mt-10 text-gray-500">Loading…</div>
      ) : venues.length === 0 ? (
        <div className="mt-10 border-2 border-dashed border-gray-300 rounded-xl p-12 text-center">
          <p className="text-lg text-gray-700">You haven't saved any places yet.</p>
          <Button asChild className="mt-4 rounded-full bg-blue-600 hover:bg-blue-700"><Link to="/search">Browse venues</Link></Button>
        </div>
      ) : (
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {venues.map(v => <VenueCard key={v.id} venue={v} />)}
        </div>
      )}
    </div>
  );
}
